const GLOBAL_ROLES = new Set([
  'DEVELOPER', 'WACHLEITUNG', 'WACHLEITUNG_VERTRETUNG',
]);

const canEditEinteilung = (user, targetAbteilungId, effectivePermissions = []) => {
  if (!user) return false;
  if (user.rolle === 'DEVELOPER') return true;
  if (!effectivePermissions.includes('einteilung.write')) return false;
  if (GLOBAL_ROLES.has(user.rolle)) return true;
  return !!targetAbteilungId && user.abteilung_id === targetAbteilungId;
};

module.exports = { canEditEinteilung };
